// src/pages/BlogDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import { getBlogBySlug } from '../api/blogApi';


const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlogBySlug(id).then(res => setBlog(res.data)).finally(() => setLoading(false));
  }, [id]);

  const containerStyle = { maxWidth: '800px', margin: '50px auto', padding: '0 20px' };
  const titleStyle = { fontSize: '28px', marginBottom: '20px' };
  const contentStyle = { lineHeight: '1.6', color: '#555' };

  if (loading) return <LoadingSpinner />;
  if (!blog) return <p style={{ textAlign: 'center' }}>Blog not found.</p>;

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>{blog.title}</h2>
      <p style={contentStyle}>{blog.content}</p>
    </div>
  );
};

export default BlogDetail;
